import script from "./KiwishLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./KiwishLoader.vue?vue&type=script&setup=true&lang=js"

import "./KiwishLoader.vue?vue&type=style&index=0&id=ce7604a6&lang=css"

const __exports__ = script;

export default __exports__